import styled from 'styled-components';

interface IProps {
	sendToTop?: boolean;
}

export default styled.div<IProps>`
	position: relative;

	${(props) => (props.sendToTop === true ? 'z-index: 4;' : '')}
`;
